<h2 class="text-center p-5">{{data?.title}}</h2>

<ng-container *ngIf="data.mode !== 'delete'; else deleteMode">
<div class="row mb-3 p-3 w-100">
    <form [formGroup]="form" class="row g-3">
    
        <div class="col-md-6 mb-3">
            <label for="name" class="form-label required-field">Nombre</label>
            <input type="text" id="name" class="form-control" formControlName="name" />
            <div *ngIf="form.get('name')?.touched && form.get('name')?.invalid" class="text-danger">
                El nombre es obligatorio y debe tener máximo 1000 caracteres.
            </div>
        </div>
        <div class="col-md-6 mb-3">
            <label for="rating" class="form-label required-field">Clasificación</label>
            <input type="number" id="rating" class="form-control" formControlName="rating" />      
            <div *ngIf="form.get('rating')?.touched && form.get('rating')?.invalid" class="text-danger">
                La clasificación es obligatoria y debe ser mayor a 0.
            </div>     
        </div>
    
    </form>
    <button (click)="Accept()" class="btn btn-primary col-lg-6">Guardar</button>
    <button (click)="closeDialog()" class="btn btn-danger col-lg-6">Cancelar</button>     
</div>
</ng-container>

<ng-template #deleteMode>
    <div class="text-center w-100 p-5">
        
        <div class="mb-5">
            <h4>¿Seguro que quieres eliminar?</h4>
        </div>
        <div>
            <button (click)="Accept()" class="btn btn-primary">Si, eliminar</button>     
            <button (click)="closeDialog()" class="btn btn-danger">Cancelar</button>      
        </div>
    </div>
  </ng-template>